import { UserViewMode } from '@/store/modules/auth/type'

export type HeaderViewMode = UserViewMode.Bu | UserViewMode.Broker

export function getDefaultHeaderViewMode(availableModes: readonly HeaderViewMode[]): HeaderViewMode {
  return availableModes.includes(UserViewMode.Bu) ? UserViewMode.Bu : UserViewMode.Broker
}

export function normalizeStringValue(value: unknown, fallback = '') {
  if (value == null) {
    return fallback
  }

  return String(value)
}

export function normalizeNumberValue(value: unknown, fallback: number) {
  const nextValue = typeof value === 'number' ? value : Number(value)
  return Number.isFinite(nextValue) ? nextValue : fallback
}

export function normalizeHeaderViewMode(value: unknown, availableModes: readonly HeaderViewMode[]): HeaderViewMode {
  if ((value === UserViewMode.Bu || value === 2 || value === '2' || value === 'BU_VIEW')
    && availableModes.includes(UserViewMode.Bu)) {
    return UserViewMode.Bu
  }

  if ((value === UserViewMode.Broker || value === 1 || value === '1' || value === 'BROKER_VIEW')
    && availableModes.includes(UserViewMode.Broker)) {
    return UserViewMode.Broker
  }

  return getDefaultHeaderViewMode(availableModes)
}

export function normalizeBuId(value: unknown, defaultBuId = '') {
  const normalizedValue = normalizeStringValue(value)
  return normalizedValue || defaultBuId || ''
}
